module.exports = __webpack_public_path__ + "static/animated_armor-972858597b70eb2abbfb1c0bfa3a31ee.jpeg";